import React, { useState } from 'react';
import { setInitialPrice } from '../../utils/api';

const TokenPrice = ({ config, loadConfig, flash, f, BC, SYM, bcRate, toBC, fBC, vBC, showUsdt, isNotUsdt }) => {
  const [price, setPrice] = useState('');
  const tpBC = toBC(config.tokenPriceInUsdt);
  const oneBC_tokens = config.tokenPriceInUsdt > 0 ? (bcRate / config.tokenPriceInUsdt) : 0;

  return (
    <div className="fade-in">
      <h2 className="adm-title">Token Price</h2>
      <div className="adm-kpi-grid cols-3">
        <div className="adm-kpi card"><span className="adm-kpi-label">Current</span><strong className="adm-kpi-val mono">{BC === 'USDT' ? f(config.tokenPriceInUsdt, 8) : f(tpBC, 10)} {BC}{isNotUsdt && showUsdt ? <span className="d-usdt-eq"> ≈ {f(config.tokenPriceInUsdt, 6)} USDT</span> : ''}</strong></div>
        <div className="adm-kpi card"><span className="adm-kpi-label">1 {BC} =</span><strong className="adm-kpi-val mono">{f(oneBC_tokens, 2)} {SYM}</strong></div>
        <div className="adm-kpi card"><span className="adm-kpi-label">Liq / Supply</span><strong className="adm-kpi-val mono">{fBC(config.liquidity, 4)} {BC} / {f(config.totalSupply, 2)} {SYM}</strong></div>
      </div>
      <div className="card adm-sub">
        <h3>Set Tokens Per {BC}</h3>
        <p className="adm-hint">Price auto-adjusts via liquidity/supply formula after trades.</p>
        <div className="adm-form-grid cols-3">
          <div className="adm-field"><label>Tokens per 1 {BC}</label><input type="number" placeholder="e.g. 100" value={price} onChange={e => setPrice(e.target.value)} className="input" /></div>
          <div className="adm-field"><label>Preview</label><p className="adm-preview-text mono">{price && parseFloat(price) > 0 ? `1 ${SYM} = ${f(1/parseFloat(price), 8)} ${BC}` : '—'}</p></div>
          <div className="adm-field adm-field-end"><button className="btn btn-primary" onClick={async () => { if (!price || parseFloat(price) <= 0) { flash('Invalid', 'error'); return; } try { const r = await setInitialPrice({ tokensPerBnb: parseFloat(price) }); flash(r.message); setPrice(''); loadConfig(); } catch (e) { flash(e.response?.data?.error || 'Failed', 'error'); } }}>Set</button></div>
        </div>
      </div>
    </div>
  );
};

export default TokenPrice;